export default "__VITE_ASSET__B47DCjpQ__"